<template>
  <transition name="slide">
    <div v-if="visible" class="mobile-menu-overlay" @click.self="$emit('close')">
      <div class="mobile-menu-panel">
        <div class="mobile-menu-header">
          <div class="mobile-logo">
            <a-icon type="experiment" />
            <span>QD FTZ Chemical</span>
          </div>
          <a-icon type="close" class="close-icon" @click="$emit('close')" />
        </div>

        <nav class="mobile-nav">
          <router-link to="/" class="mobile-nav-item" @click.native="$emit('close')">
            <a-icon type="home" /> {{ $t('nav.home') }}
          </router-link>

          <div class="mobile-nav-item" @click="productsOpen = !productsOpen">
            <a-icon type="shopping" /> {{ $t('nav.products') }}
            <a-icon :type="productsOpen ? 'up' : 'down'" class="expand-icon" />
          </div>
          <div v-show="productsOpen" class="mobile-subnav">
            <router-link to="/products" class="mobile-subnav-item" @click.native="$emit('close')">
              {{ $t('nav.allProducts') }}
            </router-link>
            <router-link
              v-for="cat in categories"
              :key="cat.key"
              :to="`/products?category=${cat.key}`"
              class="mobile-subnav-item"
              @click.native="$emit('close')"
            >
              {{ locale === 'zh' ? cat.nameZh : cat.name }}
            </router-link>
          </div>

          <router-link to="/about" class="mobile-nav-item" @click.native="$emit('close')">
            <a-icon type="info-circle" /> {{ $t('nav.about') }}
          </router-link>

          <router-link to="/contact" class="mobile-nav-item" @click.native="$emit('close')">
            <a-icon type="phone" /> {{ $t('nav.contact') }}
          </router-link>
        </nav>

        <div class="mobile-menu-footer">
          <div class="mobile-lang" @click="toggleLang">
            <a-icon type="global" />
            <span>{{ locale === 'zh' ? '切换到 English' : 'Switch to 中文' }}</span>
          </div>
          <div class="mobile-search" @click="openSearch">
            <a-icon type="search" /> {{ $t('nav.search') }}
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'MobileMenu',
  props: {
    visible: Boolean
  },
  data() {
    return {
      productsOpen: false
    }
  },
  computed: {
    locale() {
      return this.$store.locale
    },
    categories() {
      return this.$store.categories
    }
  },
  methods: {
    toggleLang() {
      const newLang = this.locale === 'zh' ? 'en' : 'zh'
      this.$store.setLocale(newLang)
      this.$i18n.locale = newLang
    },
    openSearch() {
      this.$emit('close')
      // Trigger search modal
      this.$root.$emit('open-search')
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../styles/variables.less';

.mobile-menu-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.5);
}

.mobile-menu-panel {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 280px;
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.mobile-menu-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid @bg-light;

  .mobile-logo {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 700;
    color: @primary-dark;

    .anticon {
      font-size: 20px;
      color: @accent-teal;
    }
  }

  .close-icon {
    font-size: 20px;
    color: @text-secondary;
    cursor: pointer;
  }
}

.mobile-nav {
  flex: 1;
  padding: 12px 0;
}

.mobile-nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  font-size: 15px;
  color: @text-primary;
  cursor: pointer;
  transition: background @duration-fast;
  text-decoration: none;

  &:hover, &.router-link-active {
    background: @bg-light;
    color: @primary-dark;
  }

  .expand-icon {
    margin-left: auto;
    font-size: 12px;
    color: @text-secondary;
  }
}

.mobile-subnav {
  background: @bg-light;
}

.mobile-subnav-item {
  display: block;
  padding: 12px 20px 12px 52px;
  font-size: 14px;
  color: @text-secondary;
  text-decoration: none;
  transition: all @duration-fast;

  &:hover, &.router-link-active {
    color: @primary-dark;
    background: darken(@bg-light, 3%);
  }
}

.mobile-menu-footer {
  padding: 16px 20px;
  border-top: 1px solid @bg-light;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mobile-lang, .mobile-search {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  font-size: 13px;
  color: @text-secondary;
  cursor: pointer;
  border-radius: 4px;
  transition: all @duration-fast;

  &:hover {
    background: @bg-light;
    color: @primary-dark;
  }
}

// 过渡动画
.slide-enter-active, .slide-leave-active {
  transition: all @duration-normal @ease-professional;

  .mobile-menu-panel {
    transition: transform @duration-normal @ease-professional;
  }
}

.slide-enter, .slide-leave-to {
  opacity: 0;

  .mobile-menu-panel {
    transform: translateX(-100%);
  }
}
</style>
